import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Services from '@/views/Services.vue'
import Products from '@/views/Products.vue'
import ServiceDetail from '@/views/ServiceDetail.vue'
import News from '@/views/News.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import AboutList from '@/views/AboutList.vue'
import AboutDetail from '../views/AboutDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/services/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/services/detail',
    name: 'ServiceDetail',
    component: ServiceDetail
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/about/list',
    name: 'AboutList',
    component: AboutList
  },
  {
    path: '/about/detail',
    name: 'AboutDetail',
    component: AboutDetail
  },

  {
    path: '/news/detail',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由切换后保持翻译状态
router.afterEach((to, from) => {
  setTimeout(() => {
    if (typeof translate !== 'undefined' && translate.to && translate.to !== '') {
      translate.execute()
    }
  }, 300)
})

export default router
